import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CheckoutStatus} from '@gatewee/types/checkout';

@Pipe({
  name: 'checkoutStatus',
  pure: false,
  standalone: false,
})
export class CheckoutStatusPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: CheckoutStatus | string): string {
    return (
      this.translate.instant(`enums.checkoutStatus.${value}`) ||
      this.translate.instant('common.unknown')
    );
  }
}
